import { render, staticRenderFns } from "./apply-withdraw.vue?vue&type=template&id=00afc1d2&scoped=true"
import script from "./apply-withdraw.vue?vue&type=script&lang=js"
export * from "./apply-withdraw.vue?vue&type=script&lang=js"
import style0 from "./apply-withdraw.vue?vue&type=style&index=0&id=00afc1d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00afc1d2",
  null
  
)

export default component.exports